module.exports = __webpack_public_path__ + "img/printstat-rgb.c82f1367.png";